import { Component, Input, OnChanges, SimpleChanges, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import * as d3 from "d3";

@Component({
  selector: 'app-tree-map-tooltip',
  template: `
    <div class="tooltip-card">
      <!-- Header -->
      <div class="tooltip-header">
        <span *ngIf="chartType=='group'" class="d-flex align-items-center" style="gap: 5px;">
          <span>
            <svg width="12" height="12" viewBox="0 0 12 12">
              <circle cx="6" cy="6" r="5" [attr.fill]="colorPalette[tooltipData.status]"></circle>
            </svg>
          </span>
          <span>{{  tooltipData?.groupName || tooltipData?.name }}</span>
        </span>
        <span *ngIf="chartType!='group'">
          {{  tooltipData?.name }}  
        </span>
      </div>

      <!-- Content -->
      <div class="tooltip-body" [style.display]="chartType=='group' ? 'none' : 'flex'">
        <!-- Donut container -->
        <div class="donut-wrapper">
          <div #tooltipContainer></div>
        </div>

        <!-- Stats list -->
        <div class="stats-list">
          <div *ngFor="let a of tooltipData?.items" class="stats-row">
            <div class="label-group">
              <span class="dot" [style.background-color]="colorPalette[a.result_typ]"></span>
              <span class="label">{{ a.result_typ }}</span>
            </div>


        <div class="d-flex align-items-center" style="gap: 5px;min-width: 30px;text-align: left;justify-content: left;">
            <!-- UP TREND -->
            <span *ngIf="a.trend=='UP'" class="icon up">
              <svg width="12" height="12" viewBox="0 0 8 8" fill="none">
                <path 
                  d="M7.2 2.25L4.44 5.02 2.98 3.56 0.79 5.75" 
                  [attr.stroke]="spikeColor ? '#FF4567' : '#3AC97C'" 
                  stroke-linecap="round" stroke-linejoin="round"/>
                <path 
                  d="M5.46 2.25h1.75V4" 
                  [attr.stroke]="spikeColor ? '#FF4567' : '#3AC97C'" 
                  stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>

            <!-- DOWN TREND -->
            <span *ngIf="a.trend=='DOWN'" class="icon down">
              <svg width="12" height="12" viewBox="0 0 8 8" fill="none">
                <path 
                  d="M7.2 5.75L4.44 2.98 2.98 4.44 0.79 2.25" 
                  [attr.stroke]="spikeColor ? '#3AC97C' : '#FF4567'" 
                  stroke-linecap="round" stroke-linejoin="round"/>
                <path 
                  d="M5.46 5.75h1.75V4" 
                  [attr.stroke]="spikeColor ? '#3AC97C' : '#FF4567'" 
                  stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>

            <!-- NO TREND -->
            <span *ngIf="!a.trend" class="icon down">
              <svg width="12" height="12" viewBox="0 0 8 8" fill="none"></svg>
            </span>

            <div>{{ Math.abs(a.difference) }}</div>
        </div>


            <div class="today">{{ a.today_count }}</div>
          </div>
        </div>
      </div>
      <div class="tooltip-body" [style.display]="chartType=='group' ? 'block' : 'none'">
        <!-- difference: 4
group: "ERROR"
name: "authorised_refills"
status: "ERROR"
trend: "UP"
value: 4 
groupName
-->

        <div class="info-card">
          <div class="d-flex align-items-center justify-content-between">
            <span class="label">Table Name:</span>
            <span class="value">{{ tooltipData.groupName }}</span>
          </div>

          <div class="d-flex align-items-center justify-content-between">
            <span class="label">Column Name:</span>
            <span class="value">{{ tooltipData.name }}</span>
          </div>

          <div class="d-flex align-items-center justify-content-between">
            <span class="label">No of Defects:</span>
            <span class="value">{{ tooltipData.value || 0}}</span>
          </div>

          <div class="d-flex align-items-center justify-content-between">
            <span class="label">Trend:</span>
            <span class="value">
              <span class="d-flex align-items-center" style="gap: 5px;">
                  <!-- UP TREND -->
                <span *ngIf="tooltipData.trend=='UP'" class="icon up">
                  <svg width="12" height="12" viewBox="0 0 8 8" fill="none">
                    <path 
                      d="M7.2 2.25L4.44 5.02 2.98 3.56 0.79 5.75" 
                      [attr.stroke]="spikeColor ? '#FF4567' : '#3AC97C'" 
                      stroke-linecap="round" stroke-linejoin="round"/>
                    <path 
                      d="M5.46 2.25h1.75V4" 
                      [attr.stroke]="spikeColor ? '#FF4567' : '#3AC97C'" 
                      stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>

                <!-- DOWN TREND -->
                <span *ngIf="tooltipData.trend=='DOWN'" class="icon down">
                  <svg width="12" height="12" viewBox="0 0 8 8" fill="none">
                    <path 
                      d="M7.2 5.75L4.44 2.98 2.98 4.44 0.79 2.25" 
                      [attr.stroke]="spikeColor ? '#3AC97C' : '#FF4567'" 
                      stroke-linecap="round" stroke-linejoin="round"/>
                    <path 
                      d="M5.46 5.75h1.75V4" 
                      [attr.stroke]="spikeColor ? '#3AC97C' : '#FF4567'" 
                      stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>

                <!-- NO TREND -->
                <span *ngIf="tooltipData.trend=='LINE'" class="icon down">
                  <svg width="13" height="6" viewBox="0 0 13 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.75 2.75H10.0833" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9.41406 0.75L11.4141 2.75L9.41406 4.75" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>

                {{ Math.abs(tooltipData.difference) || 0 }}
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>

  `,
  styles: [`
    .tooltip-card {
      background: #1a1a1a;
      color: #fff;
      border-radius: 8px;
      
      display: inline-block; /* shrink to content */
      font-family: "Poppins";
      box-shadow: 0 2px 8px rgba(0,0,0,0.3);
    }

    .tooltip-header {
      background: #262626;
      font-weight: 600;
      border-radius: 8px 8px 0;
      font-size: 14px;
      padding: 10px 14px;
      font-family: "Poppins";
      margin-bottom: 8px;
    }

    .tooltip-body {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 5px 14px 10px;
    }

    .donut-wrapper {
      flex-shrink: 0;
    }

    .stats-list {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    .stats-row {
      display: grid;
      grid-auto-flow: column;
      grid-auto-columns: max-content; /* each cell only as wide as its content */
      align-items: center;
      gap: 12px;
      font-size: 13px;
    }

    .label-group {
      display: flex;
      align-items: center;
      gap: 6px;
      min-width: 80px;
    }

    .label-group .dot {
      width: 6px;
      height: 6px;
      border-radius: 50%;
    }
    
    .today {
      min-width: 20px;
      text-align: left;
      justify-content: left;
      font-variant-numeric: tabular-nums;
      white-space: nowrap; /* prevent wrapping */
      font-family: "Poppins";
    }

    //////////
    // group
    .info-card {
      width: 260px;
      color: #ffffff;
      font-family: 'Poppins';
    }

    .label {
      color: #858585;
      font-size: 12px;
      font-weight: 500;
      white-space: nowrap;
      flex-shrink: 0;
    }

    .value {
      color: #ffffff;
      font-size: 12px;
      font-weight: 500;
      text-align: right;
      word-break: break-all;
      overflow-wrap: anywhere;
    }
  `]
})
export class TreeMapTooltipComponent implements OnChanges, AfterViewInit {

  @ViewChild("tooltipContainer", { static: false }) tooltipContainer!: ElementRef<HTMLDivElement>;
  @Input() tooltipData: any;
  @Input("colorPalette") colorPalette: any; 
  @Input("chartType") chartType: any; 
  @Input("spikeColor") spikeColor:boolean = false

  Math = Math;
  private data: any[] = [];
  private totalValue: number = 0;
  private initialized = false;
  previousTootipName:any;

  ngAfterViewInit(): void {
    this.initialized = true;
    if (this.tooltipData && this.tooltipData.name != this.previousTootipName) {
      this.previousTootipName = this.tooltipData.name
      this.prepareDataAndRender();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if (changes['tooltipData'] && (changes['tooltipData'].currentValue != changes['tooltipData'].previousValue) && this.initialized) {
    //   console.log(changes['tooltipData'])
    //   this.prepareDataAndRender();
    // }
  }

  private prepareDataAndRender() {
    this.data = this.tooltipData?.items || [];
    this.totalValue = this.tooltipData?.value || 0;
    this.renderDonutChart();
  }

  private renderDonutChart(): void {
    const element = this.tooltipContainer?.nativeElement;
    if (!element || !this.data.length) return;

    d3.select(element).selectAll('svg').remove(); // clear old svg

    const width = 100, height = 100, radius = 40;

    const svg = d3.select(element)
      .append('svg')
      .attr('width', width)
      .attr('height', height)
      .append('g')
      .attr('transform', `translate(${width / 2}, ${height / 2})`);

    const arc = d3.arc<any>()
      .innerRadius(radius - 15)
      .outerRadius(radius);

    const pie = d3.pie<any>()
      .sort(null)
      .value((d: any) => d.today_count);

    // Animate donut segments
    svg.selectAll('path')
      .data(pie(this.data), (d: any) => d.data?.result_typ)
      .enter()
      .append('path')
      .attr('fill', (d: any) => this.colorPalette[d.data.result_typ])
      .transition()
      .duration(0)
      .attrTween('d', function(d) {
        const i = d3.interpolate(d.startAngle, d.endAngle);
        return function(t) {
          d.endAngle = i(t);
          return arc(d) as string;
        };
      });

    // Center text
    svg.append('text')
      .attr('text-anchor', 'middle')
      .attr('dy', '0.35em')
      .style('fill', '#fff')
      .style('font-size', '16px')
      .style('font-weight', '600')
      .text(this.totalValue);
  }
}
